export enum Pages {
  Root,
  Participant,
  CreateToken,
  Help,
}
